module.exports = __webpack_public_path__ + "images/bertjonkcc3a081c5038d1743b7c9e7ce87dd628.png";